import { Component } from 'react';
import { connect } from 'react-redux';
import { asField } from 'informed';
import { SelectInput } from './common';

export default connect((state) => ({
  messages: state.messages,
  theme: state.theme
}))(
  asField(
    class extends Component {
      onInputWithValueUpdateChange = (value, actionMeta) => {
        const { fieldApi, onInputChange } = this.props;

        if (
          !fieldApi ||
          actionMeta.action === 'input-blur' ||
          actionMeta.action === 'menu-close'
        ) {
          return;
        }

        this.onValueChange(value);

        if (onInputChange) onInputChange(value, actionMeta);
      };

      onValueChange = (value) => {
        const { fieldApi, messages, onChange, isRequired } = this.props;

        const isEmpty =
          (value !== 0 && !value) || (Array.isArray(value) && !value.length);

        fieldApi.setError(
          isRequired && isEmpty ? messages.commonRequired : undefined
        );

        fieldApi.setValue(value);
        fieldApi.setTouched(true);
        if (onChange) onChange(value);
      };

      render() {
        const {
          ariaLabel,
          async = false,
          components,
          creatable = false,
          defaultOptions = false,
          disabled = false,
          dropdownStyles,
          error,
          filterOption,
          fieldState,
          id,
          inputValue,
          isClearable = false,
          isMulti = false,
          isRequired = false,
          isSearchable = false,
          isValidNewOption,
          keepContainerOpen,
          label,
          loadingMessage,
          loadOptions,
          maxMenuHeight,
          menuAlign,
          menuPlacement = 'auto',
          menuWidth,
          messages,
          noOptionsMessage,
          onInputChange,
          options,
          placeholder,
          showLabelForSelectedElement,
          style,
          theme,
          updateValueOnInputChange,
          usePortal,
          value
        } = this.props;

        const selectProps = {
          ariaLabel,
          components,
          error: error,
          defaultOptions: defaultOptions,
          dropdownStyles: dropdownStyles,
          filterOption: filterOption,
          isDisabled: disabled,
          id: id,
          inputId: `${id}-input`,
          inputValue,
          isClearable: isClearable,
          isMulti: isMulti,
          isSearchable: isSearchable,
          isValidNewOption,
          keepContainerOpen,
          maxMenuHeight,
          menuAlign,
          menuPlacement: menuPlacement,
          menuWidth,
          noOptionsMessage: () => messages.commonNoOptions,
          onInputChange,
          placeholder: placeholder || `${messages.commonSelect}...`,
          required: isRequired,
          showLabelForSelectedElement,
          usePortal
        };

        return (
          <div
            className="select"
            ref={(el) => {
              this.selectElement = el;
            }}
            style={style}
            {...(label ? { 'aria-label': label } : {})}
          >
            {creatable && async ? (
              <SelectInput
                {...selectProps}
                async={true}
                creatable={true}
                defaultOptions={defaultOptions}
                formatCreateLabel={(value) =>
                  `${messages.commonAdd} "${value}"`
                }
                isSearchable={true}
                loadingMessage={() => loadingMessage}
                loadOptions={loadOptions}
                noOptionsMessage={() => noOptionsMessage}
                onChange={(value) =>
                  this.onValueChange(
                    isMulti && value && value.length
                      ? arr.map((obj) => obj.value)
                      : value?.value
                      ? value.value
                      : null
                  )
                }
                onInputChange={
                  updateValueOnInputChange && !isMulti
                    ? this.onInputWithValueUpdateChange
                    : onInputChange
                }
                placeholder={placeholder || `${messages.commonAdd}...`}
                value={
                  value !== undefined
                    ? value
                    : isMulti && fieldState.value?.map
                    ? fieldState.value.map((value) => ({
                        label: value,
                        value: value
                      }))
                    : fieldState.value
                    ? fieldState.value
                    : null
                }
              />
            ) : creatable ? (
              <SelectInput
                {...selectProps}
                creatable={true}
                formatCreateLabel={(value) =>
                  `${messages.commonAdd} "${value}"`
                }
                isSearchable={true}
                noOptionsMessage={() => noOptionsMessage}
                onChange={(arr) =>
                  this.onValueChange(
                    arr && arr.length ? arr.map((obj) => obj.value) : null
                  )
                }
                options={options}
                placeholder={placeholder || `${messages.commonAdd}...`}
                value={
                  value !== undefined
                    ? value
                    : fieldState.value?.map
                    ? fieldState.value.map((value) => ({
                        label: value,
                        value: value
                      }))
                    : null
                }
              />
            ) : async ? (
              <SelectInput
                {...selectProps}
                defaultOptions={defaultOptions}
                async={true}
                loadingMessage={() => loadingMessage}
                loadOptions={loadOptions}
                noOptionsMessage={() => noOptionsMessage}
                onChange={(option) =>
                  this.onValueChange(
                    option
                      ? Array.isArray(option)
                        ? option.map((element) => element.value)
                        : option.value
                      : null
                  )
                }
              />
            ) : (
              <SelectInput
                {...selectProps}
                noOptionsMessage={() => noOptionsMessage}
                options={options}
                onChange={(option) =>
                  this.onValueChange(
                    option
                      ? Array.isArray(option)
                        ? option.map((obj) => obj.value)
                        : option.value
                      : null
                  )
                }
                value={
                  value !== undefined
                    ? value
                    : options
                    ? isMulti && fieldState.value?.map
                      ? fieldState.value?.map((value) => ({
                          label: showLabelForSelectedElement
                            ? options.find((option) => option.value === value)
                                ?.label
                            : value,
                          value: value
                        }))
                      : options.filter(
                          (option) => option.value === fieldState.value
                        )[0]
                    : null
                }
              />
            )}

            {error ? <div className="error-message">{error}</div> : null}

            <style jsx>{`
              .error-message {
                color: ${theme.dangerColor};
                font-size: 1.3rem;
                font-weight: 400;
                padding: 3px;
              }
            `}</style>
          </div>
        );
      }
    }
  )
);
